module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy1"
  }, [_vm._v("Publisher: Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Project Editor: Alice Mace Nakanishi")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Compiler: Lindsay Conner")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover/Book Designer: April Mostek")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Page Layout Artist: Casey Dukes")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Production Coordinator: Joe Edge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography by Nissa Brehmer, Christina Carty-Francis, and Diane Pedersen of C&T Publishing, Inc., unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("For further information and similar projects, see the book listed after each artist’s bio.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0